export default __webpack_public_path__ + "static/media/loginRight.7a9d438e.svg";